import { Outlet, Link, useLocation } from "react-router-dom";
import { useEffect } from "react";

export default function App() {
  const { pathname } = useLocation();

  // Odredi jezik iz URL-a (default HR)
  const lang = pathname.startsWith("/en") ? "en" : "hr";

  // Basic meta tagovi po jeziku (Title/Description)
  useEffect(() => {
    const titles = {
      hr: "Somnia madraci – Savršen san, svaki dan",
      en: "Somnia Mattresses – Perfect sleep, every night",
    };
    const descs = {
      hr: "Somnia nudi premium madrace izrađene u Hrvatskoj: udobnost, potpora i dugotrajnost.",
      en: "Somnia offers premium mattresses crafted in Croatia: comfort, support and durability.",
    };

    document.title = titles[lang];

    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = descs[lang];
  }, [pathname, lang]);

  return (
    <div className="min-h-screen flex flex-col bg-navy text-white">
      {/* HEADER */}
      <header className="sticky top-0 z-50 bg-navy/90 backdrop-blur border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          {/* Logo */}
          <Link
            to={lang === "en" ? "/en" : "/"}
            className="flex items-center gap-3 hover:opacity-90 transition"
          >
            <img
              src="/images/somnia-logo.png"
              alt="Somnia logo"
              className="w-8 h-8 object-contain"
            />
            <span className="text-lg font-semibold text-gold tracking-wide">
              Somnia
            </span>
          </Link>

          {/* Navigation */}
          <nav className="flex items-center gap-6 text-sm font-medium">
            <Link
              to={lang === "en" ? "/en/products" : "/hr/proizvodi"}
              className="hover:text-gold transition"
            >
              {lang === "en" ? "Products" : "Proizvodi"}
            </Link>
            <Link to="/admin" className="hover:text-gold transition">
              Admin
            </Link>
          </nav>

          {/* Lang Switch */}
          <nav className="flex items-center gap-2">
            {lang === "en" ? (
              <Link
                to="/"
                className="text-sm border border-white/20 px-3 py-1 rounded-full hover:border-gold hover:text-gold transition"
                aria-label="Hrvatski"
              >
                HR
              </Link>
            ) : (
              <Link
                to="/en"
                className="text-sm border border-white/20 px-3 py-1 rounded-full hover:border-gold hover:text-gold transition"
                aria-label="English"
              >
                EN
              </Link>
            )}
          </nav>
        </div>
      </header>

      {/* MAIN */}
      <main className="flex-grow">
        <Outlet />
      </main>

      {/* FOOTER */}
      <footer className="border-t border-white/10 bg-navy/90 mt-10">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between text-gray-400 text-sm">
          <p>
            © {new Date().getFullYear()} Somnia Sleep ·{" "}
            <Link
              to={lang === "en" ? "/en/products" : "/hr/proizvodi"}
              className="hover:text-gold transition"
            >
              {lang === "en" ? "Shop mattresses" : "Kupnja madraca"}
            </Link>
          </p>
          <p className="hidden sm:block">Premium madraci izrađeni u Hrvatskoj</p>
        </div>
      </footer>
    </div>
  );
}
